import Vue from 'vue'
import input from '@/components/controls/x-input'
import textarea from '@/components/controls/x-textarea'
import checkbox from '@/components/controls/x-checkbox'
import button from '@/components/controls/x-button'
import form from '@/components/controls/x-form'
import formSubmit from '@/components/controls/x-form-submit'
import select from '@/components/controls/x-select'
import spinner from '@/components/controls/x-spinner'
import radioGroup from '@/components/controls/x-radio-group'
import radioButton from '@/components/controls/x-radio-button'
import radioButtonLarge from '@/components/controls/x-radio-button-large'
import slider from '@/components/controls/x-slider'
import rangeSlider from '@/components/controls/x-range-slider'
import datePicker from '@/components/controls/x-date-picker'
import dateRangePicker from '@/components/controls/x-date-range-picker'
import buttonSwitch from '@/components/controls/molecules/x-button-switch'
import tag from '@/components/controls/x-tag'
import multiSelect from '@/components/controls/x-multiselect'
import userAvatar from '@/components/controls/x-user-avatar'
import menu from '@/components/controls/x-menu'
import dateFilters from '@/components/controls/x-date-filters'
import xTagCloud from '@/components/controls/x-tag-cloud'
import XTelInput from '@/components/controls/XTelInput'

Vue.component('x-input', input)
Vue.component('x-textarea', textarea)
Vue.component('x-button', button)
Vue.component('x-form', form)
Vue.component('x-form-submit', formSubmit)
Vue.component('x-select', select)
Vue.component('x-radio-group', radioGroup)
Vue.component('x-radio-button', radioButton)
Vue.component('x-radio-button-large', radioButtonLarge)
Vue.component('x-spinner', spinner)
Vue.component('x-checkbox', checkbox)
Vue.component('x-range-slider', rangeSlider)
Vue.component('x-slider', slider)
Vue.component('x-date-picker', datePicker)
Vue.component('x-date-range-picker', dateRangePicker)
Vue.component('x-button-switch', buttonSwitch)
Vue.component('x-tag', tag)
Vue.component('x-multiselect', multiSelect)
Vue.component('x-user-avatar', userAvatar)
Vue.component('x-menu', menu)
Vue.component('x-date-filters', dateFilters)
Vue.component('x-tag-cloud', xTagCloud)
Vue.component('XTelInput', XTelInput)
